<template>
  <div class="ce-activeFilterTag">
    <span class="iconContainer">
      <fa-icon
        icon="times"
        @click.prevent="remove" />
    </span>

    <span class="ce-activeFilterTag-content">
      <span class="ce-activeFilterTag-label">
        {{ label }}:
      </span>
      <span class="ce-activeFilterTag-value">
        {{ valueLabel }}
      </span>
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    filterKey: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: false,
      default: null
    }
  },
  computed: {
    ...mapGetters(['urlFilters']),
    valueLabel() {
      if (this.value) {
        return this.value;
      }

      return this.urlFilters[this.filterKey];
    }
  },
  methods: {
    remove() {
      const url = this.$cloneObject(this.urlFilters);

      this.$trackEvent('filter', 'remove', {
        filterType: 'active_filter_tag',
        filterKey: this.filterKey,
        filterLabel: this.label,
      });

      delete url[this.filterKey];

      this.$store.dispatch('setUrlFilters', url);
    }
  }
};
</script>

<style lang="less">
@import (reference) "~styles/includes/base";

.ce-activeFilterTag {
  border: 1px solid @color-mono-70;
  border-radius: 50px;
  display: flex;
  align-items: stretch;
  .ms(-2);

  > span {
    padding: @space-2 @space-3;
    display: flex;
    align-items: center;
  }

  span.iconContainer {
    flex: none;
    border-top-left-radius: 50px;
    border-bottom-left-radius: 50px;
    padding-right: @space-3;

    svg {
      transition: color 250ms ease-in-out;
    }

    &:hover {
      cursor: pointer;

      svg {
        color: @color-error;
      }
    }
  }

  span.ce-activeFilterTag-content {
    padding-left: 0;
    border-top-right-radius: 50px;
    border-bottom-right-radius: 50px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: flex-start;

    .ce-activeFilterTag-label {
      font-weight: bold;
    }
  }
}

</style>
